import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { assertNexusPermission } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { PartnerSchedulingImportRunStatus } from '../entities/PartnerSchedulingImportRun.js';
import { partnerWorkbookImport } from '../partner-import/partner-import.js';
import { updateImportStatus } from './subscribe-import-status.js';

export const importPartnerNetworkWorkbook = registerMutation({
  operationName: 'importPartnerNetworkWorkbook',
  params: [
    { name: 'base64Content', type: () => String },
    { name: 'sourceFilename', type: () => String },
  ],
  resolve: (base64Content: string, sourceFilename: string) => async () => {
    await assertNexusPermission(NexusPermission.PartnerSchedulingImport, 'partner workbook import');
    try {
      // Trigger background import process (fire-and-forget)
      void partnerWorkbookImport(base64Content, sourceFilename);
      updateImportStatus({
        status: PartnerSchedulingImportRunStatus.RUNNING,
        messages: [`Import run reserved: ${sourceFilename}. Running...`],
      });
      logger.info('✅ PARTNER::Import workbook triggered');
      return ['Import process started. Please wait while the file is being processed...'];
    } catch (err) {
      logger.error({ err }, '❌ PARTNER::Import workbook failed');
      throw err;
    }
  },
  type: () => [String],
});
